import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useLocation } from "react-router-dom";
import { getProductName } from "../../utilities/productColor";

function Celltrion(props) {
  const location = useLocation();
  const productName = getProductName(location.pathname).toLocaleLowerCase();

  const prcBaseCode = "US-PSP-25-00007v3    07/26";
  const prcZymfentraCode = "US-ZYM-25-00046    04/25";
  const prcStobocloCode = "US-STB-25-00009    06/25";
  const prcOsenveltCode = "US-OSV-25-00009    06/25";
  const prcSteqymaCode = "US-CT-P43-24-00032    06/25";
  const prcAvtozmaCode = "US-AVT-25-00016    09/25";
  const prcOmlycloCode = "US-OML-26-00007    07/26";
  const adalimumabCode = "US-YUF-26-00005V2    03/26";
  const prcVegzelmaCode = "US-VEG-26-00016    06/26"; //US-VEG-26-00016  06/26
  
  
  const prcCode = productName.includes("stoboclo")
    ? prcStobocloCode
    : productName.includes("osenvelt")
      ? prcOsenveltCode
      : productName.includes("zymfentra")
        ? prcZymfentraCode
        : productName.includes("steqeyma")
          ? prcSteqymaCode
          : productName.includes("avtozma")
            ? prcAvtozmaCode
            : productName.includes("omlyclo")
            ? prcOmlycloCode
            : productName.includes("adalimumab")
              ? adalimumabCode
            : productName.includes("vegzelma")
              ? prcVegzelmaCode
              : prcBaseCode;

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="popup"
      >
        {productName === "stoboclo" && (
          <Modal.Body className="popup-padding">
            <div className="txt-just">
              <p style={{ paddingBottom: "15px" }}>
                Celltrion CARES<sup className="reg">&reg;</sup> Co-pay
                Assistance Program:<br></br>
                STOBOCLO<sup className="reg">&reg;</sup> (denosumab-bmwo) Terms
                and Conditions
              </p>
              <div className="pl-17 mt-15">
                These Terms and Conditions are valid for STOBOCLO as of the date
                published until amended or terminated by Celltrion (“Program
                Period”). As a condition of participation in the Program,
                participants understand and agree that Celltrion may, in its
                sole discretion, limit, rescind, revoke, terminate, or amend the
                Program at any time, for any reason, without notice. It is the
                responsibility of participants to review these Terms and
                Conditions each time before relying on any Program benefits.
              </div>
              <p className="lhight2">1. Program Overview </p>
              <div className="pl-17 mt-15">
                The Celltrion CARES<sup className="reg">&reg;</sup> Co-pay
                Assistance Program (“Program”) seeks to help Eligible Patients
                (defined below) with certain out-of-pocket costs (OOP) for
                STOBOCLO. Under the Program, Eligible Patients may pay as little
                as $0 for each dose of STOBOCLO. The Program is subject to
                certain limitations set out below, including Qualifying Expenses
                (defined below), maximum limits, available funding, and patient
                eligibility requirements or other restrictions. Actual
                per-prescription savings for Qualifying Expenses may vary, and
                patients may be responsible for OOP costs not covered under this
                Program.
              </div>
              <p className="lhight2">2. Patient Eligibility </p>
              <div className="pl-17 mt-15">
                <div className="mb10">
                  To qualify for Program benefits, the patient must meet the
                  following eligibility requirements (“Eligible Patients”):
                </div>
                <ul>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      <strong>Have Commercial Insurance:</strong> Patient must
                      have and use private/commercial health insurance that
                      provides at least some coverage for STOBOCLO. Patients who
                      do not have coverage for STOBOCLO or do not elect to use
                      their commercial health plan to cover at least some of the
                      cost of STOBOCLO are ineligible for the Program.
                      Additionally, patients are ineligible for the Program
                      where their insurance policy prohibits such co-pay
                      assistance programs. It is the patient’s responsibility to
                      check with their insurance carrier to confirm that their
                      participation in the Program is not inconsistent with
                      insurance carrier’s requirements; including satisfying any
                      conditions imposed by their carrier for participation in
                      the Program.
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <strong>Not Have Federal or State Health Insurance:</strong>{" "}
                    Patients are ineligible for the Program if they are covered,
                    in whole or in part, under:
                    <ul>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          Medicaid (including Medicaid patients enrolled in a
                          qualified health plan purchased through a health
                          insurance exchange marketplace established by a state
                          government or the federal government),
                        </div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>Medicare (Part A or B),</div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          Medicare Part D or Medicare Advantage plan (regardless
                          of whether a specific prescription is covered),
                          TRICARE, Veterans Affairs healthcare or the Civilian
                          Health and Medical Program (CHAMPVA),
                        </div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          Puerto Rico Government Health Insurance Plan
                          (“Healthcare Reform” formerly known as “La Reforma de
                          Salud”),
                        </div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          A State prescription drug assistance program, or
                        </div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          Any other state or federal medical or pharmaceutical
                          benefit program or pharmaceutical assistance program
                          (collectively, “Government Programs”).
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
                <div className="mb10">
                  If at any time in the future, a patient begins receiving
                  prescription drug coverage for STOBOCLO under any such
                  Government Program(s), the patient is ineligible for the
                  Program and must call Celltrion CARES at 1-877-81CONNC
                  (1-877-812-6662) to stop participation in the Program
                  immediately.
                </div>
                <ul>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      <strong>Not Self-Pay:</strong> The Program is not valid
                      for self-pay or cash-paying patients (i.e., patients
                      without commercial health insurance, patients with health
                      insurance who lack coverage for STOBOCLO, or patients who
                      do not seek to use commercial health insurance to pay for
                      STOBOCLO under their plan).
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      <strong>Residency and Age: </strong>Patient must be 18
                      years of age or older and reside in the United States or
                      the Commonwealth of Puerto Rico for at least 6 months and
                      live within and under the guidance of a healthcare
                      provider (HCP) within the United States or the
                      Commonwealth of Puerto Rico. Additionally, STOBOCLO
                      covered under the Program must originate and be shipped to
                      locations in the United States or the Commonwealth of
                      Puerto Rico.
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      <strong>On-label Prescription:</strong> Patient must be
                      under the care of a physician and prescribed STOBOCLO for
                      an FDA-approved indication.
                    </div>
                  </li>
                </ul>
              </div>
              <p className="lhight2">3. Program Enrollment for Co-pay Cards</p>
              <div className="pl-17 mt-15">
                <ul>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    Eligible Patients must be enrolled in the Program and meet
                    all Patient Eligibility requirements.
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Patients or their duly licensed provider(s),
                      pharmacist(s), caretakers, or legal guardians may complete
                      the Program enrollment process either via the Celltrion
                      CONNECT<sup className="reg">&reg;</sup> Patient Support
                      Program or online through the Celltrion CARES website.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Patients, or those enrolling on behalf of the patient
                      agree to provide all required information and legal
                      consents necessary for Program administration by Celltrion
                      CARES. Anyone enrolling the patient in the Program
                      represents and warrants all information provided is true
                      and accurate as of the date provided.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Celltrion CARES will review the application to determine
                      if the patient is eligible for the Program.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      If the patient is eligible for the Program, Celltrion
                      CARES will provide the Eligible Patient with virtual
                      co-pay card details that can be used to cover the cost of
                      Qualifying Expenses at their dispensing pharmacy.{" "}
                    </div>
                  </li>
                </ul>
              </div>
              <p className="lhight2">4. Retroactive Enrollment</p>
              <div className="pl-17 mt-15">
                <ul>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      For OOP costs incurred by Eligible Patients for STOBOCLO
                      under their commercial insurance plan before Program
                      enrollment. The Program will cover eligible costs with a
                      look back date not to exceed 90 days prior to the date the
                      Eligible Patient was enrolled in the Program.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Claims must be processed at the point of sale by the
                      pharmacy where the claim originated for the dispense.
                    </div>
                  </li>
                </ul>
              </div>
              <p className="lhight2">5. Qualifying Expenses</p>
              <div className="pl-17 mt-15">
                <ul>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <strong>Qualifying Expenses:</strong> Are those OOP costs
                    incurred by Eligible Patients for STOBOCLO under their
                    commercial insurance plan during the Program period, subject
                    to maximum allowable limits. Qualifying Expenses are not
                    valid for ancillary services including office visit charges
                    or medication administration charges even if such costs are
                    associated with the administration of STOBOCLO. Enrolled
                    patients are responsible for all co-pays, deductibles,
                    coinsurance, and any other balances not covered by the
                    Program.{" "}
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      <strong>Maximum Limit:</strong> Is the total maximum limit
                      an Eligible Patient may receive for Qualifying Expenses
                      during the Program calendar year. The maximum limit is set
                      by Celltrion CARES and may be subject to change.{" "}
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      <strong>Adjustments:</strong> Qualifying Expenses may be
                      adjusted if accumulator or maximizer programs are in
                      effect to ensure that the Program is for the sole benefit
                      of the patient.
                    </div>
                  </li>
                </ul>
              </div>
              <p className="lhight2">6. Additional Criteria </p>
              <div className="pl-17 mt-15">
                <ul>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      The co-pay card is limited to one Eligible Patient per
                      application and may only be used by such patient during
                      the Program Period. The co-pay card is void if transferred
                      or substituted to any other person, or if combined with
                      any other co-pay assistance program, free trial, discount,
                      prescription savings card, or other offer. Co-pay cards
                      may also not be offered for sale, sold, purchased, traded,
                      reproduced, counterfeited, or duplicated.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Patient, pharmacy, and provider agree not to seek
                      reimbursement for all, or any part of the benefit received
                      by the patient through the Program and are responsible for
                      reporting receipt of Program benefits to any insurer,
                      health plan, or other third party who pays for or
                      reimburses any part of the medication cost paid for by the
                      Program, as may be required.{" "}
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Patients must promptly contact Celltrion CARES if their
                      insurance coverage changes.{" "}
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      The maximum number of uses per calendar year is 14.{" "}
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Automatic re-enrollment in {new Date().getFullYear() + 1}{" "}
                      is only for patients who are utilizing the Program.{" "}
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      The Program is not contingent on any past or future
                      commercial sale of STOBOCLO or otherwise void where
                      prohibited by law, taxed, or restricted.{" "}
                    </div>
                  </li>
                </ul>
              </div>
              <p className="lhight2">7. Consents and Disclaimers </p>
              <div className="pl-17 mt-15">
                <ul>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      <strong>Data Use and Consent:</strong> Data related to a
                      patient’s participation in the Program may be collected,
                      analyzed, or shared with Celltrion CARES for market
                      research and other purposes related to assessing its
                      co-pay assistance programs. Data shared with Celltrion
                      CARES for these purposes will be de-identified, meaning it
                      will not identify the patient specifically.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      <strong>Modification and Termination of Program:</strong>
                      &nbsp; Celltrion CARES reserves the right to limit,
                      rescind, revoke, terminate, or amend the Program at any
                      time without notice.
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </Modal.Body>
        )}
        {productName === "osenvelt" && (
          <Modal.Body className="popup-padding">
            <div className="txt-just">
              <p style={{ paddingBottom: "15px" }}>
                Celltrion CARES<sup className="reg">&reg;</sup> Co-pay
                Assistance Program:<br></br>
                OSENVELT<sup className="reg">&reg;</sup> (denosumab-bmwo) Terms
                and Conditions
              </p>
              <div className="pl-17 mt-15">
                These Terms and Conditions are valid for OSENVELT as of the date
                published until amended or terminated by Celltrion (“Program
                Period”). As a condition of participation in the Program,
                participants understand and agree that Celltrion may, in its
                sole discretion, limit, rescind, revoke, terminate, or amend the
                Program at any time, for any reason, without notice. It is the
                responsibility of participants to review these Terms and
                Conditions each time before relying on any Program benefits.
              </div>
              <p className="lhight2">1. Program Overview </p>
              <div className="pl-17 mt-15">
                The Celltrion CARES<sup className="reg">&reg;</sup> Co-pay
                Assistance Program (“Program”) seeks to help Eligible Patients
                (defined below) with certain out-of-pocket costs (OOP) for
                OSENVELT. Under the Program, Eligible Patients may pay as little
                as $0 for OSENVELT for each dose. The Program is subject to
                certain limitations set out below, including Qualifying Expenses
                (defined below), maximum limits, available funding, and patient
                eligibility requirements or other restrictions. Actual
                per-prescription savings for Qualifying Expenses may vary, and
                patients may be responsible for OOP costs not covered under this
                Program.
              </div>
              <p className="lhight2">2. Patient Eligibility </p>
              <div className="pl-17 mt-15">
                <div className="mb10">
                  To qualify for Program benefits, the patient must meet the
                  following eligibility requirements (“Eligible Patients”):
                </div>
                <ul>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      <strong>Have Commercial Insurance:</strong> Patient must
                      have and use private/commercial health insurance that
                      provides at least some coverage for OSENVELT. Patients who
                      do not have coverage for OSENVELT or do not elect to use
                      their commercial health plan to cover at least some of the
                      cost of OSENVELT are ineligible for the Program.
                      Additionally, patients are ineligible for the Program
                      where their insurance policy prohibits such co-pay
                      assistance programs. It is the patient’s responsibility to
                      check with their insurance carrier to confirm that their
                      participation in the Program is not inconsistent with
                      insurance carrier’s requirements; including satisfying any
                      conditions imposed by their carrier for participation in
                      the Program.
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <strong>Not Have Federal or State Health Insurance:</strong>{" "}
                    Patients are ineligible for the Program if they are covered,
                    in whole or in part, under:
                    <ul>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          Medicaid (including Medicaid patients enrolled in a
                          qualified health plan purchased through a health
                          insurance exchange marketplace established by a state
                          government or the federal government),
                        </div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>Medicare (Part A or B),</div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          Medicare Part D or Medicare Advantage plan (regardless
                          of whether a specific prescription is covered),
                          TRICARE, Veterans Affairs healthcare or the Civilian
                          Health and Medical Program (CHAMPVA),
                        </div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          Puerto Rico Government Health Insurance Plan
                          (“Healthcare Reform” formerly known as “La Reforma de
                          Salud”),
                        </div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          A State prescription drug assistance program, or
                        </div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          Any other state or federal medical or pharmaceutical
                          benefit program or pharmaceutical assistance program
                          (collectively, “Government Programs”).
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
                <div className="mb10">
                  If at any time in the future, a patient begins receiving
                  prescription drug coverage for OSENVELT under any such
                  Government Program(s), the patient is ineligible for the
                  Program and must call Celltrion CARES at 1-877-81CONNC
                  (1-877-812-6662) to stop participation in the Program
                  immediately.
                </div>
                <ul>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      <strong>Not Self-Pay:</strong> The Program is not valid
                      for self-pay or cash-paying patients (i.e., patients
                      without commercial health insurance, patients with health
                      insurance who lack coverage for OSENVELT, or patients who
                      do not seek to use commercial health insurance to pay for
                      OSENVELT under their plan).
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      <strong>Residency and Age: </strong>Patient must be 18
                      years of age or older and reside in the United States or
                      the Commonwealth of Puerto Rico for at least 6 months and
                      live within and under the guidance of a healthcare
                      provider (HCP) within the United States or the
                      Commonwealth of Puerto Rico. Additionally, OSENVELT
                      covered under the Program must originate and be shipped to
                      locations in the United States or the Commonwealth of
                      Puerto Rico.
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      <strong>On-label Prescription:</strong> Patient must be
                      under the care of a physician and prescribed OSENVELT for
                      an FDA-approved indication.
                    </div>
                  </li>
                </ul>
              </div>
              <p className="lhight2">3. Program Enrollment for Co-pay Cards</p>
              <div className="pl-17 mt-15">
                <ul>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    Eligible Patients must be enrolled in the Program and meet
                    all Patient Eligibility requirements.
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Patients or their duly licensed provider(s),
                      pharmacist(s), caretakers, or legal guardians may complete
                      the Program enrollment process either via the Celltrion
                      CONNECT<sup className="reg">&reg;</sup> Patient Support
                      Program or online through the Celltrion CARES website.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Patients, or those enrolling on behalf of the patient
                      agree to provide all required information and legal
                      consents necessary for Program administration by Celltrion
                      CARES. Anyone enrolling the patient in the Program
                      represents and warrants all information provided is true
                      and accurate as of the date provided.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Celltrion CARES will review the application to determine
                      if the patient is eligible for the Program.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      If the patient is eligible for the Program, Celltrion
                      CARES will provide the Eligible Patient with virtual
                      co-pay card details that can be used to cover the cost of
                      Qualifying Expenses at their dispensing pharmacy.{" "}
                    </div>
                  </li>
                </ul>
              </div>
              <p className="lhight2">4. Retroactive Enrollment</p>
              <div className="pl-17 mt-15">
                <ul>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      For OOP costs incurred by Eligible Patients for OSENVELT
                      under their commercial insurance plan before Program
                      enrollment. The Program will cover eligible costs with a
                      look back date not to exceed 90 days prior to the date the
                      Eligible Patient was enrolled in the Program.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Claims must be processed at the point of sale by the
                      pharmacy where the claim originated for the dispense.
                    </div>
                  </li>
                </ul>
              </div>
              <p className="lhight2">5. Qualifying Expenses</p>
              <div className="pl-17 mt-15">
                <ul>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <strong>Qualifying Expenses:</strong> Are those OOP costs
                    incurred by Eligible Patients for OSENVELT under their
                    commercial insurance plan during the Program period, subject
                    to maximum allowable limits. Qualifying Expenses are not
                    valid for ancillary services including office visit charges
                    or medication administration charges even if such costs are
                    associated with the administration of OSENVELT. Enrolled
                    patients are responsible for all co-pays, deductibles,
                    coinsurance, and any other balances not covered by the
                    Program.{" "}
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      <strong>Maximum Limit:</strong> Is the total maximum limit
                      an Eligible Patient may receive for Qualifying Expenses
                      during the Program calendar year. The maximum limit is set
                      by Celltrion CARES and may be subject to change.{" "}
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      <strong>Adjustments:</strong> Qualifying Expenses may be
                      adjusted if accumulator or maximizer programs are in
                      effect to ensure that the Program is for the sole benefit
                      of the patient.
                    </div>
                  </li>
                </ul>
              </div>
              <p className="lhight2">6. Additional Criteria </p>
              <div className="pl-17 mt-15">
                <ul>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      The co-pay card is limited to one Eligible Patient per
                      application and may only be used by such patient during
                      the Program Period. The co-pay card is void if transferred
                      or substituted to any other person, or if combined with
                      any other co-pay assistance program, free trial, discount,
                      prescription savings card, or other offer. Co-pay cards
                      may also not be offered for sale, sold, purchased, traded,
                      reproduced, counterfeited, or duplicated.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Patient, pharmacy, and provider agree not to seek
                      reimbursement for all, or any part of the benefit received
                      by the patient through the Program and are responsible for
                      reporting receipt of Program benefits to any insurer,
                      health plan, or other third party who pays for or
                      reimburses any part of the medication cost paid for by the
                      Program, as may be required.{" "}
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Patients must promptly contact Celltrion CARES if their
                      insurance coverage changes.{" "}
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      The maximum number of uses per calendar year is 14.{" "}
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Automatic re-enrollment in {new Date().getFullYear() + 1}{" "}
                      is only for patients who are utilizing the Program.{" "}
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      The Program is not contingent on any past or future
                      commercial sale of OSENVELT or otherwise void where
                      prohibited by law, taxed, or restricted.{" "}
                    </div>
                  </li>
                </ul>
              </div>
              <p className="lhight2">7. Consents and Disclaimers </p>
              <div className="pl-17 mt-15">
                <ul>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      <strong>Data Use and Consent:</strong> Data related to a
                      patient’s participation in the Program may be collected,
                      analyzed, or shared with Celltrion CARES for market
                      research and other purposes related to assessing its
                      co-pay assistance programs. Data shared with Celltrion
                      CARES for these purposes will be de-identified, meaning it
                      will not identify the patient specifically.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      <strong>Modification and Termination of Program:</strong>
                      &nbsp; Celltrion CARES reserves the right to limit,
                      rescind, revoke, terminate, or amend the Program at any
                      time without notice.
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </Modal.Body>
        )}
        {productName === "steqeyma" && (
          <Modal.Body className="popup-padding">
            <div className="txt-just">
              <p>
                Celltrion CARES<sup className="reg">&reg;</sup> Co-pay
                Assistance Program:<br></br>
                STEQEYMA<sup className="reg">&reg;</sup> (ustekinumab-stba)
                Terms and Conditions
              </p>
              <p className="lhight">
                Definition, Rules and Eligibility, and Terms and Conditions
              </p>
              <div className="pl-17 mt-15">
                These Terms and Conditions are valid for STEQEYMA as of the date
                published until amended or terminated by Celltrion (“Program
                Period”). As a condition of participation in the Program,
                participants understand and agree that Celltrion may, in its
                sole discretion, limit, rescind, revoke, terminate, or amend the
                Program at any time, for any reason, without notice. It is the
                responsibility of participants to review these Terms and
                Conditions each time before relying on any Program benefits.
              </div>
              <p className="lhight2">1. Program Overview </p>
              <div className="pl-17 mt-15">
                The Celltrion CARES<sup className="reg">&reg;</sup> Co-pay
                Assistance Program (“Program”) seeks to help Eligible Patients
                (defined below) with certain out-of-pocket costs (OOP) for
                STEQEYMA. Under the Program, Eligible Patients may pay as little
                as $0 for STEQEYMA for each fill of a one-month prescription. If
                the pharmacy can fill a 3-month supply, the Eligible Patient may
                pay no more than $0. The Program is subject to certain
                limitations set out below, including Qualifying Expenses
                (defined below), maximum limits, available funding, and patient
                eligibility requirements or other restrictions. Actual
                per-prescription savings for Qualifying Expenses may vary, and
                patients may be responsible for OOP costs not covered under this
                Program.
              </div>
              <p className="lhight2">2. Patient Eligibility </p>
              <div className="pl-17 mt-15">
                <div className="mb10">
                  To qualify for Program benefits, the patient must meet the
                  following eligibility requirements (“Eligible Patients”):
                </div>
                <ul>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      <strong>Have Commercial Insurance:</strong> Patient must
                      have and use private/commercial health insurance that
                      provides at least some coverage for STEQEYMA. Patients who
                      do not have coverage for STEQEYMA or do not elect to use
                      their commercial health plan to cover at least some of the
                      cost of STEQEYMA are ineligible for the Program.
                      Additionally, patients are ineligible for the Program
                      where their insurance policy prohibits such co-pay
                      assistance programs. It is the patient’s responsibility to
                      check with their insurance carrier to confirm that their
                      participation in the Program is not inconsistent with
                      insurance carrier’s requirements; including satisfying any
                      conditions imposed by their carrier for participation in
                      the Program.
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <strong>Not Have Federal or State Health Insurance:</strong>{" "}
                    Patients are ineligible for the Program if they are covered,
                    in whole or in part, under:
                    <ul>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          Medicaid (including Medicaid patients enrolled in a
                          qualified health plan purchased through a health
                          insurance exchange marketplace established by a state
                          government or the federal government),
                        </div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>Medicare (Part A or B),</div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          Medicare Part D or Medicare Advantage plan (regardless
                          of whether a specific prescription is covered),
                        </div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          TRICARE, Veterans Affairs healthcare or the Civilian
                          Health and Medical Program (CHAMPVA),
                        </div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          Puerto Rico Government Health Insurance Plan
                          (“Healthcare Reform” formerly known as “La Reforma de
                          Salud”),
                        </div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          A State prescription drug assistance program, or
                        </div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          Any other state or federal medical or pharmaceutical
                          benefit program or pharmaceutical assistance program
                          (collectively, “Government Programs”).
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
                <div className="mb10">
                  If at any time in the future, a patient begins receiving
                  prescription drug coverage for STEQEYMA under any such
                  Government Program(s), the patient is ineligible for the
                  Program and must call Celltrion CARES at 1-877-81CONNC
                  (1-877-812-6662) to stop participation in the Program
                  immediately.
                </div>
                <ul>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      <strong>Not Self-Pay:</strong> The Program is not valid
                      for self-pay or cash-paying patients (i.e., patients
                      without commercial health insurance, patients with health
                      insurance who lack coverage for STEQEYMA, or patients who
                      do not seek to use commercial health insurance to pay for
                      STEQEYMA under their plan).
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      <strong>Residency and Age: </strong> Patient must be 18
                      years of age or older and reside in the United States or
                      the Commonwealth of Puerto Rico for at least 6 months and
                      live within and under the guidance of a healthcare
                      provider (HCP) within the United States or the
                      Commonwealth of Puerto Rico. Additionally, STEQEYMA
                      covered under the Program must originate and be shipped to
                      locations in the United States or the Commonwealth of
                      Puerto Rico.
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      <strong>On-label Prescription:</strong> Patient must be
                      under the care of a physician and prescribed STEQEYMA for
                      an FDA-approved indication.
                    </div>
                  </li>
                </ul>
              </div>
              <p className="lhight2">3. Program Enrollment for Co-pay Cards</p>
              <div className="pl-17 mt-15">
                <ul>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    Eligible Patients must be enrolled in the Program and meet
                    all Patient Eligibility requirements.
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Patients or their duly licensed provider(s),
                      pharmacist(s), caretakers, or legal guardians may complete
                      the Program enrollment process either via the Celltrion
                      CONNECT<sup className="reg">&reg;</sup> Patient Support
                      Program or online through the Celltrion CARES website.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Patients, or those enrolling on behalf of the patient
                      agree to provide all required information and legal
                      consents necessary for Program administration by Celltrion
                      CARES. Anyone enrolling the patient in the Program
                      represents and warrants all information provided is true
                      and accurate as of the date provided.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Celltrion CARES will review the application to determine
                      if the patient is eligible for the Program.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      If the patient is eligible for the Program, Celltrion
                      CARES will provide the Eligible Patient with virtual
                      co-pay card details that can be used to cover the cost of
                      Qualifying Expenses at their dispensing pharmacy.{" "}
                    </div>
                  </li>
                </ul>
              </div>
              <p className="lhight2">4. Retroactive Enrollment</p>
              <div className="pl-17 mt-15">
                <ul>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      For OOP costs incurred by Eligible Patients for STEQEYMA
                      under their commercial insurance plan before Program
                      enrollment. The Program will cover eligible costs with a
                      look back date not to exceed 90 days prior to the date the
                      Eligible Patient was enrolled in the Program.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Claims must be processed at the point of sale by the
                      pharmacy where the claim originated for the dispense.
                    </div>
                  </li>
                </ul>
              </div>
              <p className="lhight2">5. Qualifying Expenses</p>
              <div className="pl-17 mt-15">
                <ul>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <strong>Qualifying Expenses:</strong> Are those OOP costs
                    incurred by Eligible Patients for STEQEYMA under their
                    commercial insurance plan during the Program period, subject
                    to maximum allowable limits. Qualifying Expenses are not
                    valid for ancillary services including office visit charges
                    or medication administration charges even if such costs are
                    associated with the administration of STEQEYMA. Enrolled
                    patients are responsible for all co-pays, deductibles,
                    coinsurance, and any other balances not covered by the
                    Program.{" "}
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      <strong>Maximum Limit:</strong> Is the total maximum limit
                      an Eligible Patient may receive for Qualifying Expenses
                      during the Program calendar year. The maximum limit is set
                      by Celltrion CARES and may be subject to change.{" "}
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      <strong>Adjustments:</strong> Qualifying Expenses may be
                      adjusted if accumulator or maximizer programs are in
                      effect to ensure that the Program is for the sole benefit
                      of the patient.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Patients, or those enrolling on behalf of the patient
                      agree to provide all required information and legal
                      consents necessary for Program administration by Celltrion
                      CARES. Anyone enrolling the patient in the Program
                      represents and warrants all information provided is true
                      and accurate as of the date provided.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Celltrion CARES will review the application to determine
                      if the patient is eligible for the Program.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      If the patient is eligible for the Program, Celltrion
                      CARES will provide the Eligible Patient with virtual
                      co-pay card details that can be used to cover the cost of
                      Qualifying Expenses at their dispensing pharmacy.{" "}
                    </div>
                  </li>
                </ul>
              </div>
              <p className="lhight2">6. Additional Criteria </p>
              <div className="pl-17 mt-15">
                <ul>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      The co-pay card is limited to one Eligible Patient per
                      application and may only be used by such patient during
                      the Program Period. The co-pay card is void if transferred
                      or substituted to any other person, or if combined with
                      any other co-pay assistance program, free trial, discount,
                      prescription savings card, or other offer. Co-pay cards
                      may also not be offered for sale, sold, purchased, traded,
                      reproduced, counterfeited, or duplicated.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Patient, pharmacy, and provider agree not to seek
                      reimbursement for all, or any part of the benefit received
                      by the patient through the Program and are responsible for
                      reporting receipt of Program benefits to any insurer,
                      health plan, or other third party who pays for or
                      reimburses any part of the medication cost paid for by the
                      Program, as may be required.{" "}
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Patients must promptly contact Celltrion CARES if their
                      insurance coverage changes.{" "}
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      The maximum number of uses per calendar year is 14.{" "}
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Automatic re-enrollment in 2026 is only for patients who
                      are utilizing the Program.{" "}
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      The Program is not contingent on any past or future
                      commercial sale of STEQEYMA or otherwise void where
                      prohibited by law, taxed, or restricted.{" "}
                    </div>
                  </li>
                </ul>
              </div>
              <p className="lhight2">7. Consents and Disclaimers </p>
              <div className="pl-17 mt-15">
                <ul>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      <strong>Data Use and Consent:</strong> Data related to a
                      patient’s participation in the Program may be collected,
                      analyzed, or shared with Celltrion CARES for market
                      research and other purposes related to assessing its
                      co-pay assistance programs. Data shared with Celltrion
                      CARES for these purposes will be de-identified, meaning it
                      will not identify the patient specifically.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      <strong>Modification and Termination of Program:</strong>
                      &nbsp; Celltrion CARES reserves the right to limit,
                      rescind, revoke, terminate, or amend the Program at any
                      time without notice.
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </Modal.Body>
        )}
        {productName === "omlyclo" && (
          <Modal.Body className="popup-padding">
            <div className="txt-just">
              <p style={{ paddingBottom: "15px" }}>
                Celltrion CARES<sup className="reg">&reg;</sup> Co-pay
                Assistance Program:<br></br>
                OMLYCLO<sup className="reg">&reg;</sup> (omalizumab-igec) Terms
                and Conditions
              </p>
              <div className="pl-17 mt-15">
                These Terms and Conditions are valid for OMLYCLO as of the date
                published until amended or terminated by Celltrion (“Program
                Period”). As a condition of participation in the Program,
                participants understand and agree that Celltrion may, in its
                sole discretion, limit, rescind, revoke, or amend the Program at
                any time, for any reason, without notice. It is the
                responsibility of participants to review these Terms and
                Conditions each time before relying on any Program benefits.
              </div>
              <p className="lhight2">1. Program Overview </p>
              <div className="pl-17 mt-15">
                The Celltrion CARES<sup className="reg">&reg;</sup> Co-pay
                Assistance Program (“Program”) seeks to help Eligible Patients
                (defined below) with certain out-of-pocket costs (OOP) for
                OMLYCLO. Under the Program, Eligible Patients may pay as little
                as [$0] for each dose of OMLYCLO. The Program is subject to
                certain limitations set out below, including Qualifying Expenses
                (defined below), maximum limits, available funding, and patient
                eligibility requirements or other restrictions. Actual
                per-prescription savings for Qualifying Expenses may vary, and
                patients may be responsible for OOP costs not covered under this
                Program.
              </div>
              <p className="lhight2">2. Patient Eligibility </p>
              <div className="pl-17 mt-15">
                <div className="mb10">
                  To qualify for Program benefits, the patient must meet the
                  following eligibility requirements (“Eligible Patients”):
                </div>
                <ul>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      <strong>Have Commercial Insurance:</strong> Patient must
                      have and use private/commercial health insurance that
                      provides at least some coverage for OMLYCLO. Patients who
                      do not have coverage for OMLYCLO or do not elect to use
                      their commercial health plan to cover at least some of the
                      cost of OMLYCLO are ineligible for the Program.
                      Additionally, patients are ineligible for the Program
                      where their insurance policy prohibits such co-pay
                      assistance programs. It is the patient’s responsibility to
                      check with their insurance carrier to confirm that their
                      participation in the Program is not inconsistent with
                      insurance carrier’s requirements; including satisfying any
                      conditions imposed by their carrier for participation in
                      the Program.
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <strong>Not Have Federal or State Health Insurance:</strong>{" "}
                    Patients are ineligible for the Program if they are covered,
                    in whole or in part, under:
                    <ul>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          Medicaid (including Medicaid patients enrolled in a
                          qualified health plan purchased through a health
                          insurance exchange marketplace established by a state
                          government or the federal government),
                        </div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>Medicare</div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          Medicare Part D or Medicare Advantage plan (regardless
                          of whether a specific prescription is covered),
                          TRICARE, Veterans Affairs healthcare or the Civilian
                          Health and Medical Program (CHAMPVA),
                        </div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          Puerto Rico Government Health Insurance Plan
                          (“Healthcare Reform” formerly known as “La Reforma de
                          Salud”),
                        </div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          A State prescription drug assistance program, or
                        </div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          Any other state or federal medical or pharmaceutical
                          benefit program or pharmaceutical assistance program
                          (collectively, “Government Programs”).
                        </div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          The administration co-pay benefit is not valid for
                          patients who reside or receive treatment in a
                          restricted state (e.g. Massachusetts or Rhode Island).
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
                <div className="mb10">
                  If at any time in the future, a patient begins receiving
                  prescription drug coverage for OMLYCLO under any such
                  Government Program(s), the patient is ineligible for the
                  Program and must call Celltrion CARES at 1-877-812-6662 to
                  stop participation in the Program immediately.
                </div>
                <ul>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      <strong>Not Self-Pay:</strong> The Program is not valid
                      for self-pay or cash-paying patients (i.e., patients
                      without commercial health insurance, patients with health
                      insurance who lack coverage for OMLYCLO, or patients who
                      do not seek to use commercial health insurance to pay for
                      OMLYCLO under their plan).
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      <strong>Age: </strong>Patient must be 18 years of age or
                      older, or have a caregiver or legally authorized person to
                      manage the patient’s co-pay assistance.
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      <strong>Residence: </strong>Patient must reside in the
                      United States or the Commonwealth of Puerto Rico for at
                      least 6 months and live within and under the guidance of a
                      healthcare provider (HCP) within the United States or the
                      Commonwealth of Puerto Rico. Additionally, OMLYCLO covered
                      under the Program must originate and be shipped to
                      locations in the United States or the Commonwealth of
                      Puerto Rico.
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      <strong>On-label Prescription: </strong>Patient must be
                      under the care of a physician and prescribed OMLYCLO for
                      an FDA-approved indication.
                    </div>
                  </li>
                </ul>
              </div>
              <p className="lhight2">3. Program Enrollment for Co-pay Cards</p>
              <div className="pl-17 mt-15">
                <ul>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      Eligible Patients must be enrolled in the Program and meet
                      all Patient Eligibility requirements.
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      Patients or their duly licensed provider(s),
                      pharmacist(s), caretakers, or legal guardians may complete
                      the Program enrollment process either via the Celltrion
                      CONNECT<sup className="reg">&reg;</sup> Patient Support
                      Program or online through the Celltrion CARES website.
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      Patients, or those enrolling on behalf of the patient
                      agree to provide all required information and legal
                      consents necessary for Program administration by Celltrion
                      CARES. Anyone enrolling the patient in the Program
                      represents and warrants all information provided is true
                      and accurate as of the date provided.
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      Celltrion CARES will review the application to determine
                      if the patient is eligible for the Program.
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      If the patient is eligible for the Program, Celltrion
                      CARES will provide the Eligible Patient with virtual
                      co-pay card details that can be used to cover the cost of
                      Qualifying Expenses at their dispensing pharmacy.
                    </div>
                  </li>
                </ul>
              </div>
              <p className="lhight2">4. Retroactive Enrollment</p>
              <div className="pl-17 mt-15">
                <ul>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      For OOP costs incurred by Eligible Patients for OMLYCLO
                      under their commercial insurance plan before Program
                      enrollment. The Program will cover eligible costs with a
                      look back date not to exceed 90 days prior to the date the
                      Eligible Patient was enrolled in the Program.
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      Pharmacy claims must be processed at the point of sale by
                      the pharmacy where the claim originated for the dispense.
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      Timely claim submission: claims must be submitted within
                      180 days from the date of service.
                    </div>
                  </li>
                </ul>
              </div>
              <p className="lhight2">5. Qualifying Expenses</p>
              <div className="pl-17 mt-15">
                <ul>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      <strong>Qualifying Expenses: </strong>Are those OOP costs
                      incurred by Eligible Patients for OMLYCLO under their
                      commercial insurance plan during the Program period,
                      subject to maximum allowable limits. Qualifying expenses
                      only include the cost of OMLYCLO and the administration of
                      OMLYCLO. They do not include office visit charges.
                      Enrolled patients are responsible for all co-pays,
                      deductibles, coinsurance, and any other balances not
                      covered by the Program.
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      <strong>Maximum Limit: </strong>Is the total maximum limit
                      an Eligible Patient may receive for Qualifying Expenses
                      during the Program calendar year. The maximum limit is set
                      by Celltrion CARES and may be subject to change.
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      <strong>Adjustments:</strong> Qualifying Expenses may be
                      adjusted if accumulator or maximizer programs are in
                      effect to ensure that the Program is for the sole benefit
                      of the patient. The value of the program is intended
                      exclusively for the benefit of the patient. The Program is
                      not intended for the benefit of third parties, including
                      without limitation, third-party payers, pharmacy benefit
                      managers, or their agents. If Celltrion determines that a
                      third party has implemented a program that adjusts patient
                      cost-sharing obligations based on the availability of
                      support under the program, and/or excludes the assistance
                      provided under the Program from counting towards the
                      patients deductible or out-of-pocket cost limitations,
                      Celltrion may impose a per-fill cap on the cost-sharing
                      assistance available under the Program.
                    </div>
                  </li>
                </ul>
              </div>
              <p className="lhight2">6. Additional Criteria</p>
              <div className="pl-17 mt-15">
                <ul>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      The co-pay card is limited to one Eligible Patient per
                      application and may only be used by such patient during
                      the Program Period. The co-pay card is void if transferred
                      or substituted to any other person, or if combined with
                      any other co-pay assistance program, free trial, discount,
                      prescription savings card, or other offer. Co-pay cards
                      may also not be offered for sale, sold, purchased, traded,
                      reproduced, counterfeited, or duplicated.
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      Patient, pharmacy, and provider agree not to seek
                      reimbursement for all, or any part of the benefit received
                      by the patient through the Program and are responsible for
                      reporting receipt of Program benefits to any insurer,
                      health plan, or other third party who pays for or
                      reimburses any part of the medication cost paid for by the
                      Program, as may be required.
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      Patients must promptly contact Celltrion CARES if their
                      insurance coverage changes.
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      Automatic re-enrollment is only for patients who are
                      utilizing the Program.
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      The Program is not contingent on any past or future
                      commercial sale of OMLYCLO or otherwise void where
                      prohibited by law, taxed, or restricted.
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      The Celltrion CARES<sup>&reg;</sup> Copay Card cannot be used where prohibited by law.                  
                    </div>
                  </li>
                </ul>
              </div>
              <p className="lhight2">7. Consents and Disclaimers</p>
              <div className="pl-17 mt-15">
                <ul>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      <strong>Data Use and Consent: </strong>Data related to a
                      patient’s participation in the Program may be collected,
                      analyzed, or shared with Celltrion CARES for market
                      research and other purposes related to assessing its
                      co-pay assistance programs. Data shared with Celltrion
                      CARES for these purposes will be de-identified, meaning it
                      will not identify the patient specifically.
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      <strong>Modification and Termination of Program:</strong>{" "}
                      Celltrion CARES reserves the right to limit, rescind,
                      revoke, or amend the Program at any time without notice.
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </Modal.Body>
        )}
        {productName === "avtozma" && (
          <Modal.Body className="popup-padding">
            <div className="txt-just">
              <p style={{ paddingBottom: "15px" }}>
                Celltrion CARES<sup className="reg">&reg;</sup> Co-pay
                Assistance Program:<br></br>
                AVTOZMA<sup className="reg">&reg;</sup> (tocilizumab-anoh) Terms
                and Conditions
              </p>
              <div className="pl-17 mt-15">
                These Terms and Conditions are valid for AVTOZMA as of the date
                published until amended or terminated by Celltrion (“Program
                Period”). As a condition of participation in the Program,
                participants understand and agree that Celltrion may, in its
                sole discretion, limit, rescind, revoke, terminate, or amend the
                Program at any time, for any reason, without notice. It is the
                responsibility of participants to review these Terms and
                Conditions each time before relying on any Program benefits.
              </div>
              <p className="lhight2">1. Program Overview </p>
              <div className="pl-17 mt-15">
                The Celltrion CARES<sup className="reg">&reg;</sup> Co-pay
                Assistance Program (“Program”) seeks to help Eligible Patients
                (defined below) with certain out-of-pocket costs (OOP) for
                AVTOZMA. Under the Program, Eligible Patients may pay as little
                as [$0] for each dose of AVTOZMA. The Program is subject to
                certain limitations set out below, including Qualifying Expenses
                (defined below), maximum limits, available funding, and patient
                eligibility requirements or other restrictions. Actual
                per-prescription savings for Qualifying Expenses may vary, and
                patients may be responsible for OOP costs not covered under this
                Program.
              </div>
              <p className="lhight2">2. Patient Eligibility </p>
              <div className="pl-17 mt-15">
                <div className="mb10">
                  To qualify for Program benefits, the patient must meet the
                  following eligibility requirements (“Eligible Patients”):
                </div>
                <ul>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      <strong>Have Commercial Insurance:</strong> Patient must
                      have and use private/commercial health insurance that
                      provides at least some coverage for AVTOZMA. Patients who
                      do not have coverage for AVTOZMA or do not elect to use
                      their commercial health plan to cover at least some of the
                      cost of AVTOZMA are ineligible for the Program.
                      Additionally, patients are ineligible for the Program
                      where their insurance policy prohibits such co-pay
                      assistance programs. It is the patient’s responsibility to
                      check with their insurance carrier to confirm that their
                      participation in the Program is not inconsistent with
                      insurance carrier’s requirements; including satisfying any
                      conditions imposed by their carrier for participation in
                      the Program.
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <strong>Not Have Federal or State Health Insurance:</strong>{" "}
                    Patients are ineligible for the Program if they are covered,
                    in whole or in part, under:
                    <ul>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          Medicaid (including Medicaid patients enrolled in a
                          qualified health plan purchased through a health
                          insurance exchange marketplace established by a state
                          government or the federal government),
                        </div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>Medicare (Part A or B),</div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          Medicare Part D or Medicare Advantage plan (regardless
                          of whether a specific prescription is covered),
                          TRICARE, Veterans Affairs healthcare or the Civilian
                          Health and Medical Program (CHAMPVA),
                        </div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          Puerto Rico Government Health Insurance Plan
                          (“Healthcare Reform” formerly known as “La Reforma de
                          Salud”),
                        </div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          A State prescription drug assistance program, or
                        </div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          Any other state or federal medical or pharmaceutical
                          benefit program or pharmaceutical assistance program
                          (collectively, “Government Programs”).
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
                <div className="mb10">
                  If at any time in the future, a patient begins receiving
                  prescription drug coverage for AVTOZMA under any such
                  Government Program(s), the patient is ineligible for the
                  Program and must call Celltrion CARES at 1-877-81CONNC
                  (1-877-812-6662) to stop participation in the Program
                  immediately.
                </div>
                <ul>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      <strong>Not Self-Pay:</strong> The Program is not valid
                      for self-pay or cash-paying patients (i.e., patients
                      without commercial health insurance, patients with health
                      insurance who lack coverage for AVTOZMA, or patients who
                      do not seek to use commercial health insurance to pay for
                      AVTOZMA under their plan).
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      <strong>Residency and Age: </strong>Patient must be 18
                      years of age or older and reside in the United States or
                      the Commonwealth of Puerto Rico for at least 6 months and
                      live within and under the guidance of a healthcare
                      provider (HCP) within the United States or the
                      Commonwealth of Puerto Rico. Additionally, AVTOZMA covered
                      under the Program must originate and be shipped to
                      locations in the United States or the Commonwealth of
                      Puerto Rico.
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      <strong>On-label Prescription:</strong> Patient must be
                      under the care of a physician and prescribed AVTOZMA for
                      an FDA-approved indication.
                    </div>
                  </li>
                </ul>
              </div>
              <p className="lhight2">3. Program Enrollment for Co-pay Cards</p>
              <div className="pl-17 mt-15">
                <ul>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    Eligible Patients must be enrolled in the Program and meet
                    all Patient Eligibility requirements.
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Patients or their duly licensed provider(s),
                      pharmacist(s), caretakers, or legal guardians may complete
                      the Program enrollment process either via the Celltrion
                      CONNECT<sup className="reg">&reg;</sup> Patient Support
                      Program or online through the Celltrion CARES website.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Patients, or those enrolling on behalf of the patient
                      agree to provide all required information and legal
                      consents necessary for Program administration by Celltrion
                      CARES. Anyone enrolling the patient in the Program
                      represents and warrants all information provided is true
                      and accurate as of the date provided.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Celltrion CARES will review the application to determine
                      if the patient is eligible for the Program.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      If the patient is eligible for the Program, Celltrion
                      CARES will provide the Eligible Patient with virtual
                      co-pay card details that can be used to cover the cost of
                      Qualifying Expenses at their dispensing pharmacy.{" "}
                    </div>
                  </li>
                </ul>
              </div>
              <p className="lhight2">4. Retroactive Enrollment</p>
              <div className="pl-17 mt-15">
                <ul>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      For OOP costs incurred by Eligible Patients for AVTOZMA
                      under their commercial insurance plan before Program
                      enrollment. The Program will cover eligible costs with a
                      look back date not to exceed 90 days prior to the date the
                      Eligible Patient was enrolled in the Program.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Claims must be processed at the point of sale by the
                      pharmacy where the claim originated for the dispense.
                    </div>
                  </li>
                </ul>
              </div>
              <p className="lhight2">5. Qualifying Expenses</p>
              <div className="pl-17 mt-15">
                <ul>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <strong>Qualifying Expenses:</strong> Are those OOP costs
                    incurred by Eligible Patients for AVTOZMA under their
                    commercial insurance plan during the Program period, subject
                    to maximum allowable limits. Qualifying Expenses are not
                    valid for ancillary services including office visit charges
                    or medication administration charges even if such costs are
                    associated with the administration of AVTOZMA. Enrolled
                    patients are responsible for all co-pays, deductibles,
                    coinsurance, and any other balances not covered by the
                    Program.{" "}
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      <strong>Maximum Limit:</strong> Is the total maximum limit
                      an Eligible Patient may receive for Qualifying Expenses
                      during the Program calendar year. The maximum limit is set
                      by Celltrion CARES and may be subject to change.{" "}
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      <strong>Adjustments:</strong> Qualifying Expenses may be
                      adjusted if accumulator or maximizer programs are in
                      effect to ensure that the Program is for the sole benefit
                      of the patient.
                    </div>
                  </li>
                </ul>
              </div>
              <p className="lhight2">6. Additional Criteria </p>
              <div className="pl-17 mt-15">
                <ul>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      The co-pay card is limited to one Eligible Patient per
                      application and may only be used by such patient during
                      the Program Period. The co-pay card is void if transferred
                      or substituted to any other person, or if combined with
                      any other co-pay assistance program, free trial, discount,
                      prescription savings card, or other offer. Co-pay cards
                      may also not be offered for sale, sold, purchased, traded,
                      reproduced, counterfeited, or duplicated.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Patient, pharmacy, and provider agree not to seek
                      reimbursement for all, or any part of the benefit received
                      by the patient through the Program and are responsible for
                      reporting receipt of Program benefits to any insurer,
                      health plan, or other third party who pays for or
                      reimburses any part of the medication cost paid for by the
                      Program, as may be required.{" "}
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Patients must promptly contact Celltrion CARES if their
                      insurance coverage changes.{" "}
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      The maximum number of uses per calendar year is 14.{" "}
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Automatic re-enrollment in {new Date().getFullYear() + 1}{" "}
                      is only for patients who are utilizing the Program.{" "}
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      The Program is not contingent on any past or future
                      commercial sale of AVTOZMA or otherwise void where
                      prohibited by law, taxed, or restricted.{" "}
                    </div>
                  </li>
                </ul>
              </div>
              <p className="lhight2">7. Consents and Disclaimers </p>
              <div className="pl-17 mt-15">
                <ul>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      <strong>Data Use and Consent:</strong> Data related to a
                      patient’s participation in the Program may be collected,
                      analyzed, or shared with Celltrion CARES for market
                      research and other purposes related to assessing its
                      co-pay assistance programs. Data shared with Celltrion
                      CARES for these purposes will be de-identified, meaning it
                      will not identify the patient specifically.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      <strong>Modification and Termination of Program:</strong>
                      &nbsp; Celltrion CARES reserves the right to limit,
                      rescind, revoke, terminate, or amend the Program at any
                      time without notice.
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </Modal.Body>
        )}
        {productName === "vegzelma" && (
          <Modal.Body className="popup-padding">
            <div className="txt-just">
              <p style={{ paddingBottom: "15px" }}>
                Celltrion CARES<sup className="reg">&reg;</sup> Co-pay
                Assistance Program:<br></br>
                Vegzelma<sup className="reg">&reg;</sup> (bevacizumab-adcd)
                Terms and Conditions
              </p>
              <div className="pl-17 mt-15">
                These Terms and Conditions are valid for Vegzelma as of the date
                published until amended or terminated by Celltrion (“Program
                Period”). As a condition of participation in the Program,
                participants understand and agree that Celltrion may, in its
                sole discretion, limit, rescind, revoke, terminate, or amend the
                Program at any time, for any reason, without notice. It is the
                responsibility of participants to review these Terms and
                Conditions each time before relying on any Program benefits.
              </div>
              <p className="lhight2">1. Program Overview </p>
              <div className="pl-17 mt-15">
                The Celltrion CARES<sup className="reg">&reg;</sup> Co-pay
                Assistance Program (“Program”) seeks to help Eligible Patients
                (defined below) with certain out-of-pocket costs (OOP) for
                Vegzelma. Under the Program, Eligible Patients may pay as little
                as [$0] for each dose of Vegzelma. The Program is subject to
                certain limitations set out below, including Qualifying Expenses
                (defined below), maximum limits, available funding, and patient
                eligibility requirements or other restrictions. Actual
                per-prescription savings for Qualifying Expenses may vary, and
                patients may be responsible for OOP costs not covered under this
                Program.
              </div>
              <p className="lhight2">2. Patient Eligibility </p>
              <div className="pl-17 mt-15">
                <div className="mb10">
                  To qualify for Program benefits, the patient must meet the
                  following eligibility requirements (“Eligible Patients”):
                </div>
                <ul>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      <strong>Have Commercial Insurance:</strong> Patient must
                      have and use private/commercial health insurance that
                      provides at least some coverage for Vegzelma. Patients who
                      do not have coverage for Vegzelma or do not elect to use
                      their commercial health plan to cover at least some of the
                      cost of Vegzelma are ineligible for the Program.
                      Additionally, patients are ineligible for the Program
                      where their insurance policy prohibits such co-pay
                      assistance programs. It is the patient’s responsibility to
                      check with their insurance carrier to confirm that their
                      participation in the Program is not inconsistent with
                      insurance carrier’s requirements; including satisfying any
                      conditions imposed by their carrier for participation in
                      the Program.
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <strong>Not Have Federal or State Health Insurance:</strong>{" "}
                    Patients are ineligible for the Program if they are covered,
                    in whole or in part, under:
                    <ul>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          Medicaid (including Medicaid patients enrolled in a
                          qualified health plan purchased through a health
                          insurance exchange marketplace established by a state
                          government or the federal government),
                        </div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>Medicare (Part A or B),</div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          Medicare Part D or Medicare Advantage plan (regardless
                          of whether a specific prescription is covered),
                          TRICARE, Veterans Affairs healthcare or the Civilian
                          Health and Medical Program (CHAMPVA),
                        </div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          Puerto Rico Government Health Insurance Plan
                          (“Healthcare Reform” formerly known as “La Reforma de
                          Salud”),
                        </div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          A State prescription drug assistance program, or
                        </div>
                      </li>
                      <li
                        style={{ listStyleType: "square", marginLeft: "20px" }}
                      >
                        <div>
                          Any other state or federal medical or pharmaceutical
                          benefit program or pharmaceutical assistance program
                          (collectively, “Government Programs”).
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
                <div className="mb10">
                  If at any time in the future, a patient begins receiving
                  prescription drug coverage for Vegzelma under any such
                  Government Program(s), the patient is ineligible for the
                  Program and must call Celltrion CARES at 1-877-81CONNC
                  (1-877-812-6662) to stop participation in the Program
                  immediately.
                </div>
                <ul>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      <strong>Not Self-Pay:</strong> The Program is not valid
                      for self-pay or cash-paying patients (i.e., patients
                      without commercial health insurance, patients with health
                      insurance who lack coverage for Vegzelma, or patients who
                      do not seek to use commercial health insurance to pay for
                      Vegzelma under their plan).
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      <strong>Residency and Age: </strong>Patient must be 18
                      years of age or older and reside in the United States or
                      the Commonwealth of Puerto Rico for at least 6 months and
                      live within and under the guidance of a healthcare
                      provider (HCP) within the United States or the
                      Commonwealth of Puerto Rico. Additionally, Vegzelma
                      covered under the Program must originate and be shipped to
                      locations in the United States or the Commonwealth of
                      Puerto Rico.
                    </div>
                  </li>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <div>
                      <strong>On-label Prescription:</strong> Patient must be
                      under the care of a physician and prescribed Vegzelma for
                      an FDA-approved indication.
                    </div>
                  </li>
                </ul>
              </div>
              <p className="lhight2">3. Program Enrollment for Co-pay Cards</p>
              <div className="pl-17 mt-15">
                <ul>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    Eligible Patients must be enrolled in the Program and meet
                    all Patient Eligibility requirements.
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Patients or their duly licensed provider(s),
                      pharmacist(s), caretakers, or legal guardians may complete
                      the Program enrollment process either via the Celltrion
                      CONNECT<sup className="reg">&reg;</sup> Patient Support
                      Program or online through the Celltrion CARES website.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Patients, or those enrolling on behalf of the patient
                      agree to provide all required information and legal
                      consents necessary for Program administration by Celltrion
                      CARES. Anyone enrolling the patient in the Program
                      represents and warrants all information provided is true
                      and accurate as of the date provided.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Celltrion CARES will review the application to determine
                      if the patient is eligible for the Program.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      If the patient is eligible for the Program, Celltrion
                      CARES will provide the Eligible Patient with virtual
                      co-pay card details that can be used to cover the cost of
                      Qualifying Expenses at their dispensing pharmacy.{" "}
                    </div>
                  </li>
                </ul>
              </div>
              <p className="lhight2">4. Retroactive Enrollment</p>
              <div className="pl-17 mt-15">
                <ul>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      For OOP costs incurred by Eligible Patients for Vegzelma
                      under their commercial insurance plan before Program
                      enrollment. The Program will cover eligible costs with a
                      look back date not to exceed 90 days prior to the date the
                      Eligible Patient was enrolled in the Program.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Timely Claim Submission: 180 days post-primary EOB.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Claims must be processed at the point of sale by the
                      pharmacy where the claim originated for the dispense.
                    </div>
                  </li>
                </ul>
              </div>
              <p className="lhight2">5. Qualifying Expenses</p>
              <div className="pl-17 mt-15">
                <ul>
                  <li style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <strong>Qualifying Expenses:</strong> Are those OOP costs
                    incurred by Eligible Patients for Vegzelma under their
                    commercial insurance plan during the Program period, subject
                    to maximum allowable limits. Qualifying Expenses are not
                    valid for ancillary services including office visit charges
                    or medication administration charges even if such costs are
                    associated with the administration of Vegzelma. Enrolled
                    patients are responsible for all co-pays, deductibles,
                    coinsurance, and any other balances not covered by the
                    Program.{" "}
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      <strong>Maximum Limit:</strong> Is the total maximum limit
                      an Eligible Patient may receive for Qualifying Expenses
                      during the Program calendar year. The maximum limit is set
                      by Celltrion CARES and may be subject to change.{" "}
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      <strong>Adjustments:</strong> Qualifying Expenses may be
                      adjusted if accumulator or maximizer programs are in
                      effect to ensure that the Program is for the sole benefit
                      of the patient.
                    </div>
                  </li>
                </ul>
              </div>
              <p className="lhight2">6. Additional Criteria </p>
              <div className="pl-17 mt-15">
                <ul>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      The co-pay card is limited to one Eligible Patient per
                      application and may only be used by such patient during
                      the Program Period. The co-pay card is void if transferred
                      or substituted to any other person, or if combined with
                      any other co-pay assistance program, free trial, discount,
                      prescription savings card, or other offer. Co-pay cards
                      may also not be offered for sale, sold, purchased, traded,
                      reproduced, counterfeited, or duplicated.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Patient, pharmacy, and provider agree not to seek
                      reimbursement for all, or any part of the benefit received
                      by the patient through the Program and are responsible for
                      reporting receipt of Program benefits to any insurer,
                      health plan, or other third party who pays for or
                      reimburses any part of the medication cost paid for by the
                      Program, as may be required.{" "}
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Patients must promptly contact Celltrion CARES if their
                      insurance coverage changes.{" "}
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      The maximum number of uses per calendar year is 14.{" "}
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      Automatic re-enrollment in {new Date().getFullYear() + 1}{" "}
                      is only for patients who are utilizing the Program.{" "}
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      The Program is not contingent on any past or future
                      commercial sale of Vegzelma or otherwise void where
                      prohibited by law, taxed, or restricted.{" "}
                    </div>
                  </li>
                </ul>
              </div>
              <p className="lhight2">7. Consents and Disclaimers </p>
              <div className="pl-17 mt-15">
                <ul>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      <strong>Data Use and Consent:</strong> Data related to a
                      patient’s participation in the Program may be collected,
                      analyzed, or shared with Celltrion CARES for market
                      research and other purposes related to assessing its
                      co-pay assistance programs. Data shared with Celltrion
                      CARES for these purposes will be de-identified, meaning it
                      will not identify the patient specifically.
                    </div>
                  </li>
                  <li style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <div>
                      <strong>Modification and Termination of Program:</strong>
                      &nbsp; Celltrion CARES reserves the right to limit,
                      rescind, revoke, terminate, or amend the Program at any
                      time without notice.
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </Modal.Body>
        )}
        {productName === "yuflyma" && (
          <Modal.Body className="popup-padding">
            <div className="txt-just">
              <p>
                Celltrion CARES<sup>&reg;</sup> Co-pay Assistance Program:
              </p>
              <p className="lhight">YUFLYMA Terms and Conditions</p>

              <div className="pl-17 small-text">
                These Terms and Conditions are valid for YUFLYMA
                <sup className="reg">&reg;</sup> as of the date published until
                amended or terminated by Celltrion CARES<sup>&reg;</sup>{" "}
                (“Program Period”). As a condition of participation in the
                Program, participants understand and agree that Celltrion may,
                in its sole discretion, limit, rescind, revoke, terminate, or
                amend the Program at any time, for any reason, without notice.
                It is the responsibility of participants to review these Terms
                and Conditions each time before relying on any Program benefits
              </div>

              <p className="lhight2">1. Program Overview</p>
              <div className="pl-17 mt-15">
                The Celltrion CARES<sup>&reg;</sup> Co-pay Assistance Program
                (“Program”) seeks to help Eligible Patients (defined below) with
                certain out-of-pocket costs for YUFLYMA
                <sup className="reg">&reg;</sup> (adalimumab-aaty). Under the
                Program, Eligible Patients may pay as little as $0 for YUFLYMA
                <sup className="reg">&reg;</sup> each time they present their
                Co-pay Card to fill their prescription. The Program is subject
                to certain limitations set out below, including Qualifying
                Expenses (defined below), maximum limits, available funding, and
                patient eligibility requirements or other restrictions. Actual
                per prescription savings for Qualifying Expenses may vary, and
                patients may be responsible for out-of-pocket costs not covered
                under this Program.{" "}
              </div>

              <p className="lhight2">2. Patient Eligibility</p>
              <div className="pl-17 mt-15">
                <div className="mb10">
                  To qualify for Program benefits, the patient must meet the
                  following eligibility requirements
                  <br />
                  (“Eligible Patients”):
                  <ul className="first-ul">
                    <li>
                      <strong>Have Commercial Insurance:</strong> Patient must
                      have and use private/commercial health insurance that
                      provides at least some coverage for YUFLYMA
                      <sup className="reg">&reg;</sup> (adalimumab-aaty).
                      Patients who do not have coverage for YUFLYMA or do not
                      elect to use their commercial health plan to cover at
                      least some of the cost of YUFLYMA are ineligible for the
                      Program. Additionally, patients are ineligible for the
                      Program where their insurance policy prohibits such co-pay
                      assistance programs. It is the patient’s responsibility to
                      check with their insurance carrier to confirm that their
                      participation in the Program is not inconsistent with
                      insurance carrier’s requirements; including satisfying any
                      conditions imposed by their carrier for participation in
                      the Program
                    </li>
                    <li>
                      <strong>No Federal or State Health Insurance:</strong>{" "}
                      Patients are ineligible for the Program if they are
                      covered, in whole or in part, under:
                      <ul className="second-ul">
                        <li>
                          Medicaid (including Medicaid patients enrolled in a
                          qualified health plan purchased through a health
                          insurance exchange marketplace established by a state
                          government or the federal government),
                        </li>
                        <li>Medicare (Part A or B), </li>
                        <li>
                          Medicare Part D or Medicare Advantage plan (regardless
                          of whether a specific prescription is covered),
                        </li>
                        <li>
                          TRICARE, Veterans Affairs healthcare or the Civilian
                          Health and Medical Program (CHAMPVA),
                        </li>
                        <li>
                          Puerto Rico Government Health Insurance Plan
                          (“Healthcare Reform” formerly known as “La Reforma de
                          Salud”),
                        </li>
                        <li>
                          A State prescription drug assistance program, or
                        </li>
                        <li>
                          Any other state or federal medical or pharmaceutical
                          benefit program or pharmaceutical assistance program
                          (collectively, “Government Programs”).
                        </li>
                      </ul>
                      If at any time in the future, a patient begins receiving
                      prescription drug coverage for YUFLYMA under any such
                      Government Program(s), the patient is ineligible for the
                      Program and must call Celltrion CARES<sup>&reg;</sup> at{" "}
                      <a href="tel:8778126662">
                        1-877-81CONNC (1-877-812-6662)
                      </a>{" "}
                      to stop participation in the Program immediately.
                    </li>
                    <li>
                      <strong>No Self-Pay:</strong> The Program is not valid for
                      self-pay or cash-paying patients (i.e., patients without
                      commercial health insurance, patients with health
                      insurance who lack coverage for YUFLYMA, or patients who
                      do not seek to use commercial health insurance to pay for
                      YUFLYMA under their plan).{" "}
                    </li>
                    <li>
                      <strong>Residency & Age:</strong> Patient must be a
                      resident of the United States or the Commonwealth of
                      Puerto Rico and must be 18 years or older (or have a
                      caregiver or legal guardian duly authorized to provide
                      legal consent to these Terms and Conditions on behalf of
                      the patient). Additionally, YUFLYMA covered under the
                      Program must originate, be administered to the patient,
                      and shipped to locations in the United States or the
                      Commonwealth of Puerto Rico.
                    </li>
                    <li>
                      On-label Prescription: Patient must be under the care of a
                      physician and prescribed YUFLYMA for one of the following
                      FDA-approved indications:
                      <ul className="second-ul">
                        <li>
                          <i>Rheumatoid Arthritis (RA): </i> reducing signs and
                          symptoms, inducing major clinical response, inhibiting
                          the progression of structural damage, and improving
                          physical function in adult patients with moderately to
                          severely active RA.
                        </li>
                        <li>
                          <i>Juvenile Idiopathic Arthritis (JIA): </i>reducing
                          signs and symptoms of moderately to severely active
                          polyarticular JIA in patients 2 years of age and
                          older.
                        </li>
                        <li>
                          <i>Psoriatic Arthritis (PsA): </i>reducing signs and
                          symptoms, inhibiting the progression of structural
                          damage, and improving physical function in adult
                          patients with active PsA
                        </li>
                        <li>
                          <i>Ankylosing Spondylitis (AS): </i>reducing signs and
                          symptoms in adult patients with active AS
                        </li>
                        <li>
                          <i>Crohn’s Disease (CD): </i>treatment of moderately
                          to severely active Crohn’s disease in adults and
                          pediatric patients 6 years of age and older.
                        </li>
                        <li>
                          <i>Ulcerative Colitis (UC): </i>treatment of
                          moderately to severely active ulcerative colitis in
                          adults. <u>Limitations of Use:</u> Effectiveness has
                          not been established in patients who have lost
                          response to or were intolerant to tumor necrosis
                          factor (TNF) blockers.
                        </li>
                        <li>
                          <i>Plaque Psoriasis (Ps): </i>treatment of adult
                          patients with moderate to severe chronic plaque
                          psoriasis who are candidates for systemic therapy or
                          phototherapy, and when other systemic therapies are
                          medically less appropriate
                        </li>
                        <li>
                          <i>Hidradenitis Suppurativa (HS): </i>treatment of
                          adult patients with moderate to severe hidradenitis
                          suppurativa.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
              <p className="lhight2">3. Program Enrollment for Co-pay Cards</p>
              <div className="pl-17 mt-15">
                <ul className="first-ul">
                  <li>
                    Eligible Patients must be enrolled in the Program and meet
                    all Patient Eligibility requirements
                  </li>
                  <li>
                    Patients or their duly licensed Provider(s), Pharmacist(s),
                    Caretakers or Legal Guardians may complete Program
                    Enrollment applications on behalf of the patient by
                    providing all required information and legal consents
                    necessary for Program administration by Celltrion CARES
                    <sup>&reg;</sup>. Anyone enrolling the patient in the
                    Program represents and warrants all information provided is
                    true and accurate as of the date provided.
                  </li>
                  <li>
                    Celltrion CARES<sup>&reg;</sup> will review the application
                    to determine if the Patient is Eligible for the
                    Program.{" "}
                  </li>
                  <li>
                    If the Patient is eligible for the program, Celltrion CARES
                    <sup>&reg;</sup> will provide the Patient with an electronic
                    debit card (Co-pay Card) that can be used to cover the cost
                    of Qualifying Expenses.{" "}
                  </li>
                  <li>
                    The Patient may print out the Co-pay Card and use it at
                    participating retail or specialty pharmacies
                  </li>
                </ul>
              </div>
              <p className="lhight2">4. Patient Enrollment for Rebates</p>
              <div className="pl-17 mt-15">
                <ul className="first-ul">
                  <li>
                    If Patient’s retail or specialty pharmacy does not
                    participate in the Program, Eligible Patients may be able to
                    submit a request for a rebate in connection with any
                    Qualifying Expenses. To apply for a Co-pay rebate, Eligible
                    Patients must submit Qualifying Expenses according to the
                    Rebate Process found at{" "}
                    <a
                      target="_blank"
                      href="https://www.patientrebateonline.com"
                      rel="noreferrer"
                    >
                      www.patientrebateonline.com
                    </a>
                    .
                  </li>
                  <li>
                    For Eligible Patients who are receiving their medication via
                    Mail Order Pharmacies that do not allow the use of Co-pay
                    Cards, Eligible Patients must submit Qualifying Expenses
                    according to the Rebate Process found at{" "}
                    <a
                      target="_blank"
                      href="https://www.patientrebateonline.com"
                      rel="noreferrer"
                    >
                      www.patientrebateonline.com
                    </a>
                    .
                  </li>
                  <li>
                    Patients may also apply for a rebate for Qualifying Expense
                    incurred for YUFLYMA within 90 days prior to the date the
                    patient is enrolled in the Program based on the YUFLYMA
                    administration date. Patient or Provider may contact
                    Celltrion CARES<sup>&reg;</sup> for more information.
                  </li>
                </ul>
              </div>
              <p className="lhight2">5. Qualifying Expenses</p>
              <div className="pl-17 mt-15">
                <ul className="first-ul">
                  <li>
                    <strong>Qualifying Expenses:</strong> Are those
                    out-of-pocket costs incurred by Eligible Patients for
                    YUFLYMA under their commercial insurance plan during the
                    Program period, subject to maximum allowable limits.
                    Qualifying Expenses are not valid for ancillary services
                    including office visit charges or medication administration
                    charges even if such costs are associated with the
                    administration of YUFLYMA. Enrolled patients are responsible
                    for all co-pays, deductibles, coinsurance, and any other
                    balances not covered by the Program.
                  </li>
                  <li>
                    <strong>Maximum Limit:</strong> Is the total maximum limit
                    an Eligible Patient may receive for Qualifying Expenses
                    during the Program calendar year. The maximum limit is set
                    by Celltrion CARES<sup>&reg;</sup> and may be subject to
                    change.
                  </li>
                  <li>
                    <strong>Adjustments:</strong> Qualifying Expenses may be
                    adjusted if accumulator or maximizer programs are in effect
                    to ensure that the Program is for the sole benefit of the
                    patient.
                  </li>
                </ul>
              </div>
              <p className="lhight2">6. Additional Restrictions</p>
              <div className="pl-17 mt-15">
                <ul className="first-ul">
                  <li>
                    The Co-pay Card is limited to 1 Eligible Patient per
                    application and may only be used by such patient during the
                    Program Period. The Co-pay Card is void if transferred or
                    substituted to any other person or be combined with any
                    other Co-pay Assistance Program, free trial, discount,
                    prescription savings card, or other offer. Co-pay cards may
                    also not be offered for sale, sold, purchased, traded,
                    reproduced, counterfeited, or duplicated.
                  </li>
                  <li>
                    Patient and Providers agree not to seek reimbursement for
                    all or any part of the benefit received by the Patient
                    through the Program and are responsible for reporting
                    receipt of Program benefits to any insurer, health plan, or
                    other third party who pays for or reimburses any part of the
                    medication cost paid for by the Program, as may be required.
                  </li>
                  <li>
                    Patients must promptly contact Celltrion CARES
                    <sup>&reg;</sup> if their insurance coverage changes.
                  </li>
                  <li>
                    The Program is not contingent on any past or future
                    commercial sale of YUFLYMA or otherwise void where
                    prohibited by law, taxed, or restricted.{" "}
                  </li>
                </ul>
              </div>
              <p className="lhight2">7. Consents and Disclaimers</p>
              <div className="pl-17 mt-15">
                <ul className="first-ul">
                  <li>
                    <strong>Data Use and Consent:</strong> Data related to a
                    patient’s participation in the Program may be collected,
                    analyzed, or shared with Celltrion CARES<sup>&reg;</sup> for
                    market research and other purposes related to assessing its
                    co-pay assistance programs. Data shared with Celltrion CARES
                    <sup>&reg;</sup> for these purposes will be de-identified,
                    meaning it will not identify the patient specifically.
                  </li>
                  <li>
                    <strong>Modification and Termination of Program:</strong>{" "}
                    Celltrion CARES<sup>&reg;</sup> reserves the right to limit,
                    rescind, revoke, terminate, or amend the Program at any time
                    without notice.
                  </li>
                </ul>
              </div>
            </div>
          </Modal.Body>
        )}
        {productName === "zymfentra" && (
          <Modal.Body className="popup-padding">
            <div className="txt-just">
              <p>
                Celltrion CARES<sup className="reg">&reg;</sup> Co-pay
                Assistance Program:
              </p>
              <p className="lhight">
                ZYMFENTRA<sup className="reg">&reg;</sup> Terms and Conditions
              </p>

              <div
                className="pl-17 mt-15"
                style={{ marginTop: "0px", paddingLeft: "0px" }}
              >
                These Terms and Conditions are valid for ZYMFENTRA as of the
                date published until amended or terminated by Celltrion
                (“Program Period”). As a condition of participation in the
                Program, participants understand and agree that Celltrion may,
                in its sole discretion, limit, rescind, revoke, terminate, or
                amend the Program at any time, for any reason, without notice.
                It is the responsibility of participants to review these Terms
                and Conditions each time before relying on any Program benefits.
              </div>
              <p className="lhight2">1. Program Overview</p>
              <div className="pl-17 mt-15">
                The Celltrion CARES<sup>&reg;</sup> Co-pay Assistance Program
                (“Program”) seeks to help Eligible Patients (defined below) with
                certain out-of-pocket costs (OOP) for ZYMFENTRA. Under the
                Program, Eligible Patients may pay as little as $0 for ZYMFENTRA
                for each fill of a one-month prescription. If the pharmacy can
                fill a 3-month supply, the Eligible Patient may pay no more than
                $0. The Program is subject to certain limitations set out below,
                including Qualifying Expenses (defined below), maximum limits,
                available funding, and patient eligibility requirements or other
                restrictions. Actual per-prescription savings for Qualifying
                Expenses may vary, and patients may be responsible for OOP costs
                not covered under this Program.
              </div>
              <p className="lhight2">2. Patient Eligibility</p>
              <div className="pl-17 mt-15">
                <div>
                  To qualify for Program benefits, the patient must meet the
                  following eligibility requirements (“Eligible Patients”):
                  <ul className="first-ul">
                    <li style={{ lineHeight: 1.5 }}>
                      <strong>Have Commercial Insurance:</strong> Patient must
                      have and use private/commercial health insurance that
                      provides at least some coverage for ZYMFENTRA. Patients
                      who do not have coverage for ZYMFENTRA or do not elect to
                      use their commercial health plan to cover at least some of
                      the cost of ZYMFENTRA are ineligible for the Program.
                      Additionally, patients are ineligible for the Program
                      where their insurance policy prohibits such co-pay
                      assistance programs. It is the patient’s responsibility to
                      check with their insurance carrier to confirm that their
                      participation in the Program is not inconsistent with
                      insurance carrier’s requirements; including satisfying any
                      conditions imposed by their carrier for participation in
                      the Program.
                    </li>
                    <li>
                      <strong>
                        Not Have Federal or State Health Insurance:
                      </strong>{" "}
                      Patients are ineligible for the Program if they are
                      covered, in whole or in part, under:
                      <ul className="second-ul">
                        <li style={{ lineHeight: 1.5 }}>
                          Medicaid (including Medicaid patients enrolled in a
                          qualified health plan purchased through a health
                          insurance exchange marketplace established by a state
                          government or the federal government),
                        </li>
                        <li>Medicare (Part A or B), </li>
                        <li>
                          Medicare Part D or Medicare Advantage plan (regardless
                          of whether a specific prescription is covered),
                          TRICARE, Veterans Affairs healthcare or the Civilian
                          Health and Medical Program (CHAMPVA),
                        </li>
                        <li>
                          Puerto Rico Government Health Insurance Plan
                          (“Healthcare Reform” formerly known as “La Reforma de
                          Salud”),
                        </li>
                        <li>
                          A State prescription drug assistance program, or
                        </li>
                        <li>
                          Any other state or federal medical or pharmaceutical
                          benefit program or pharmaceutical assistance program
                          (collectively, “Government Programs”).
                        </li>
                      </ul>
                      If at any time in the future, a patient begins receiving
                      prescription drug coverage for ZYMFENTRA under any such
                      Government Program(s), the patient is ineligible for the
                      Program and must call Celltrion CARES
                      <sup className="reg">&reg;</sup> at 1-877- 81CONNC
                      (1-877-812-6662) to stop participation in the Program
                      immediately.
                    </li>
                    <li>
                      <strong>Not Self-Pay:</strong> The Program is not valid
                      for self-pay or cash-paying patients (i.e., patients
                      without commercial health insurance, patients with health
                      insurance who lack coverage for ZYMFENTRA, or patients who
                      do not seek to use commercial health insurance to pay for
                      ZYMFENTRA under their plan).
                    </li>
                    <li>
                      <strong>Residency & Age:</strong> Patient must be 18 years
                      of age or older and reside in the United States or the
                      Commonwealth of Puerto Rico for at least 6 months and live
                      within and under the guidance of a healthcare provider
                      (HCP) within the United States or the Commonwealth of
                      Puerto Rico. Additionally, ZYMFENTRA covered under the
                      Program must originate and be shipped to locations in the
                      United States or the Commonwealth of Puerto Rico.
                    </li>
                    <li>
                      <strong>On-label Prescription:</strong> Patient must be
                      under the care of a physician and prescribed ZYMFENTRA for
                      an FDA-approved indication.
                    </li>
                  </ul>
                </div>
              </div>

              <p className="lhight2">3. Program Enrollment for Co-pay Cards</p>
              <div className="pl-17 mt-15">
                <ul className="first-ul">
                  <li style={{ lineHeight: 1.5 }}>
                    Eligible Patients must be enrolled in the Program and meet
                    all Patient Eligibility requirements.
                  </li>
                  <li>
                    Patients or their duly licensed provider(s), pharmacist(s),
                    caretakers, or legal guardians may complete the Program
                    enrollment process either via the Celltrion CONNECT
                    <sup className="reg">&reg;</sup> Patient Support Program or
                    online through the Celltrion CARES
                    <sup className="reg">&reg;</sup> website.
                  </li>
                  <li>
                    Patients, or those enrolling on behalf of the patient agree
                    to provide all required information and legal consents
                    necessary for Program administration by Celltrion CARES
                    <sup className="reg">&reg;</sup>. Anyone enrolling the
                    patient in the Program represents and warrants all
                    information provided is true and accurate as of the date
                    provided.
                  </li>
                  <li>
                    Celltrion CARES<sup className="reg">&reg;</sup> will review
                    the application to determine if the patient is eligible for
                    the Program.
                  </li>
                  <li>
                    If the patient is eligible for the Program, Celltrion CARES
                    <sup className="reg">&reg;</sup> will provide the Eligible
                    Patient with virtual co-pay card details that can be used to
                    cover the cost of Qualifying Expenses at their dispensing
                    pharmacy.
                  </li>
                </ul>
              </div>
              <p className="lhight2">4. Retroactive Enrollment</p>
              <div className="pl-17 mt-15">
                <ul className="first-ul">
                  <li style={{ lineHeight: 1.5 }}>
                    For OOP costs incurred by Eligible Patients for ZYMFENTRA
                    under their commercial insurance plan before Program
                    enrollment. The Program will cover eligible costs with a
                    look back date not to exceed 90 days prior to the date the
                    Eligible Patient was enrolled in the Program.
                  </li>
                  <li>
                    Claims must be processed at the point of sale by the
                    pharmacy where the claim originated for the dispense.
                  </li>
                </ul>
              </div>
              <p className="lhight2">5. Qualifying Expenses</p>
              <div className="pl-17 mt-15">
                <ul className="first-ul">
                  <li style={{ lineHeight: 1.5 }}>
                    <strong>Qualifying Expenses:</strong> Are those OOP costs
                    incurred by Eligible Patients for ZYMFENTRA under their
                    commercial insurance plan during the Program period, subject
                    to maximum allowable limits. Qualifying Expenses are not
                    valid for ancillary services including office visit charges
                    or medication administration charges even if such costs are
                    associated with the administration of ZYMFENTRA. Enrolled
                    patients are responsible for all co-pays, deductibles,
                    coinsurance, and any other balances not covered by the
                    Program.
                  </li>
                  <li>
                    <strong>Maximum Limit:</strong> Is the total maximum limit
                    an Eligible Patient may receive for Qualifying Expenses
                    during the Program calendar year. The maximum limit is set
                    by Celltrion CARES<sup className="reg">&reg;</sup> and may
                    be subject to change.
                  </li>
                  <li>
                    <strong>Adjustments:</strong> Qualifying Expenses may be
                    adjusted if accumulator or maximizer programs are in effect
                    to ensure that the Program is for the sole benefit of the
                    patient.
                  </li>
                </ul>
              </div>
              <p className="lhight2">6. Additional Criteria</p>
              <div className="pl-17 mt-15">
                <ul className="first-ul">
                  <li style={{ lineHeight: 1.5 }}>
                    The co-pay card is limited to one Eligible Patient per
                    application and may only be used by such patient during the
                    Program Period. The co-pay card is void if transferred or
                    substituted to any other person, or if combined with any
                    other co-pay assistance program, free trial, discount,
                    prescription savings card, or other offer. Co-pay cards may
                    also not be offered for sale, sold, purchased, traded,
                    reproduced, counterfeited, or duplicated.
                  </li>
                  <li>
                    Patient, pharmacy, and provider agree not to seek
                    reimbursement for all, or any part of the benefit received
                    by the patient through the Program and are responsible for
                    reporting receipt of Program benefits to any insurer, health
                    plan, or other third party who pays for or reimburses any
                    part of the medication cost paid for by the Program, as may
                    be required.
                  </li>
                  <li>
                    Patients must promptly contact Celltrion CARES
                    <sup className="reg">&reg;</sup> if their insurance coverage
                    changes.
                  </li>
                  <li>The maximum number of uses per calendar year is 14.</li>
                  <li>
                    Automatic re-enrollment in 2025 is only for patients who are
                    utilizing the Program.
                  </li>
                  <li>
                    The Program is not contingent on any past or future
                    commercial sale of ZYMFENTRA or otherwise void where
                    prohibited by law, taxed, or restricted.
                  </li>
                </ul>
              </div>
              <p className="lhight2">7. Consents and Disclaimers</p>
              <div className="pl-17 mt-15">
                <ul className="first-ul">
                  <li style={{ lineHeight: 1.5 }}>
                    <strong>Data Use and Consent:</strong> Data related to a
                    patient’s participation in the Program may be collected,
                    analyzed, or shared with Celltrion CARES
                    <sup className="reg">&reg;</sup> for market research and
                    other purposes related to assessing its co-pay assistance
                    programs. Data shared with Celltrion CARES
                    <sup className="reg">&reg;</sup> for these purposes will be
                    de-identified, meaning it will not identify the patient
                    specifically.
                  </li>
                  <li>
                    <strong>Modification and Termination of Program:</strong>{" "}
                    Celltrion CARES<sup className="reg">&reg;</sup> reserves the
                    right to limit, rescind, revoke, terminate, or amend the
                    Program at any time without notice.
                  </li>
                </ul>
              </div>
            </div>
          </Modal.Body>
        )}
        {productName === "adalimumab" && (
          <Modal.Body className="popup-padding">
            <div className="txt-just">
              <p>
                Celltrion CARES<sup className="reg">&reg;</sup> Co-pay
                Assistance Program:
              </p>
              <p className="lhight">Adalimumab-aaty Terms and Conditions</p>

              <div className="pl-17 small-text">
                These Terms and Conditions are valid for Adalimumab-aaty as of
                the date published until amended or terminated by Celltrion
                (“Program Period”). As a condition of participation in the
                Program, participants understand and agree that Celltrion may,
                in its sole discretion, limit, rescind, revoke, terminate, or
                amend the Program at any time, for any reason, without notice.
                It is the responsibility of participants to review these Terms
                and Conditions each time before relying on any Program benefits.
              </div>

              <p className="lhight2">1. Program Overview</p>
              <div className="pl-17 mt-15">
                The Celltrion CARES<sup className="reg">&reg;</sup> Co-pay
                Assistance Program (“Program”) seeks to help Eligible Patients
                (defined below) with certain out-of-pocket costs (OOP) for
                Adalimumab-aaty. Under the Program, Eligible Patients may pay as
                little as $0 for each dose of Adalimumab-aaty. The Program is
                subject to certain limitations set out below, including
                Qualifying Expenses (defined below), maximum limits, available
                funding, and patient eligibility requirements or other
                restrictions. Actual per-prescription savings for Qualifying
                Expenses may vary, and patients may be responsible for OOP costs
                not covered under this Program.
              </div>

              <p className="lhight2">2. Patient Eligibility</p>
              <div className="pl-17 mt-15">
                <div className="mb10">
                  To qualify for Program benefits, the patient must meet the
                  following eligibility requirements (“Eligible Patients”):
                  <ul className="first-ul">
                    <li>
                      <strong>Have Commercial Insurance:</strong> Patient must
                      have and use private/commercial health insurance that
                      provides at least some coverage for Adalimumab-aaty.
                      Patients who do not have coverage for Adalimumab-aaty or
                      do not elect to use their commercial health plan to cover
                      at least some of the cost of Adalimumab-aaty are
                      ineligible for the Program. Additionally, patients are
                      ineligible for the Program where their insurance policy
                      prohibits such co-pay assistance programs. It is the
                      patient’s responsibility to check with their insurance
                      carrier to confirm that their participation in the Program
                      is not inconsistent with insurance carrier’s requirements;
                      including satisfying any conditions imposed by their
                      carrier for participation in the Program.
                    </li>
                    <li>
                      <strong>
                        Not Have Federal or State Health Insurance:
                      </strong>{" "}
                      Patients are ineligible for the Program if they are
                      covered, in whole or in part, under:
                      <ul className="second-ul">
                        <li>
                          Medicaid (including Medicaid patients enrolled in a
                          qualified health plan purchased through a health
                          insurance exchange marketplace established by a state
                          government or the federal government),
                        </li>
                        <li>Medicare (Part A or B), </li>
                        <li>
                          Medicare Part D or Medicare Advantage plan (regardless
                          of whether a specific prescription is covered),
                          TRICARE, Veterans Affairs healthcare or the Civilian
                          Health and Medical Program (CHAMPVA),
                        </li>
                        <li>
                          Puerto Rico Government Health Insurance Plan
                          (“Healthcare Reform” formerly known as “La Reforma de
                          Salud”),
                        </li>
                        <li>
                          A State prescription drug assistance program, or
                        </li>
                        <li>
                          Any other state or federal medical or pharmaceutical
                          benefit program or pharmaceutical assistance program
                          (collectively, “Government Programs”).
                        </li>
                      </ul>
                      If at any time in the future, a patient begins receiving
                      prescription drug coverage for Adalimumab-aaty under any
                      such Government Program(s), the patient is ineligible for
                      the Program and must call Celltrion CARES at 1-877-81CONNC
                      (1-877-812-6662) to stop participation in the Program
                      immediately.
                    </li>
                    <li>
                      <strong>Not Self-Pay:</strong> The Program is not valid
                      for self-pay or cash-paying patients (i.e., patients
                      without commercial health insurance, patients with health
                      insurance who lack coverage for Adalimumab-aaty, or
                      patients who do not seek to use commercial health
                      insurance to pay for Adalimumab-aaty under their plan).
                    </li>
                    <li>
                      <strong>Residency & Age:</strong> Patient must be 18 years
                      of age or older and reside in the United States or the
                      Commonwealth of Puerto Rico for at least 6 months and live
                      within and under the guidance of a healthcare provider
                      (HCP) within the United States or the Commonwealth of
                      Puerto Rico. Additionally, Adalimumab-aaty covered under
                      the Program must originate and be shipped to locations in
                      the United States or the Commonwealth of Puerto Rico.
                    </li>
                    <li>
                      <strong>On-label Prescription:</strong> Patient must be
                      under the care of a physician and prescribed
                      Adalimumab-aaty for an FDA-approved indication.{" "}
                    </li>
                  </ul>
                </div>
              </div>
              <p className="lhight2">3. Program Enrollment for Co-pay Cards</p>
              <div className="pl-17 mt-15">
                <ul className="first-ul">
                  <li>
                    Eligible Patients must be enrolled in the Program and meet
                    all Patient Eligibility requirements.
                  </li>
                  <li>
                    Patients or their duly licensed provider(s), pharmacist(s),
                    caretakers, or legal guardians may complete the Program
                    enrollment process either via the Celltrion CONNECT
                    <sup className="reg">&reg;</sup> Patient Support Program or
                    online through the Celltrion CARES website.
                  </li>
                  <li>
                    Patients, or those enrolling on behalf of the patient agree
                    to provide all required information and legal consents
                    necessary for Program administration by Celltrion CARES.
                    Anyone enrolling the patient in the Program represents and
                    warrants all information provided is true and accurate as of
                    the date provided.
                  </li>
                  <li>
                    Celltrion CARES will review the application to determine if
                    the patient is eligible for the Program.
                  </li>
                  <li>
                    If the patient is eligible for the Program, Celltrion CARES
                    will provide the Eligible Patient with virtual co-pay card
                    details that can be used to cover the cost of Qualifying
                    Expenses at their dispensing pharmacy.{" "}
                  </li>
                </ul>
              </div>
              <p className="lhight2">4. Retroactive Enrollment</p>
              <div className="pl-17 mt-15">
                <ul className="first-ul">
                  <li>
                    For OOP costs incurred by Eligible Patients for
                    Adalimumab-aaty under their commercial insurance plan before
                    Program enrollment. The Program will cover eligible costs
                    with a look back date not to exceed 90 days prior to the
                    date the Eligible Patient was enrolled in the Program. 
                  </li>
                  <li>
                    Claims must be processed at the point of sale by the
                    pharmacy where the claim originated for the dispense.
                  </li>
                </ul>
              </div>
              <p className="lhight2">5. Qualifying Expenses</p>
              <div className="pl-17 mt-15">
                <ul className="first-ul">
                  <li>
                    <strong>Qualifying Expenses:</strong> Are those OOP costs
                    incurred by Eligible Patients for Adalimumab-aaty under
                    their commercial insurance plan during the Program period,
                    subject to maximum allowable limits. Qualifying Expenses are
                    not valid for ancillary services including office visit
                    charges or medication administration charges even if such
                    costs are associated with the administration of
                    Adalimumab-aaty. Enrolled patients are responsible for all
                    co-pays, deductibles, coinsurance, and any other balances
                    not covered by the Program.y other balances not covered by
                    the Program.
                  </li>
                  <li>
                    <strong>Maximum Limit:</strong> Is the total maximum limit
                    an Eligible Patient may receive for Qualifying Expenses
                    during the Program calendar year. The maximum limit is set
                    by Celltrion CARES and may be subject to change.
                  </li>
                  <li>
                    <strong>Adjustments:</strong> Qualifying Expenses may be
                    adjusted if accumulator or maximizer programs are in effect
                    to ensure that the Program is for the sole benefit of the
                    patient.
                  </li>
                </ul>
              </div>
              <p className="lhight2">6. Additional Criteria</p>
              <div className="pl-17 mt-15">
                <ul className="first-ul">
                  <li>
                    The co-pay card is limited to one Eligible Patient per
                    application and may only be used by such patient during the
                    Program Period. The co-pay card is void if transferred or
                    substituted to any other person, or if combined with any
                    other co-pay assistance program, free trial, discount,
                    prescription savings card, or other offer. Co-pay cards may
                    also not be offered for sale, sold, purchased, traded,
                    reproduced, counterfeited, or duplicated.
                  </li>
                  <li>
                    Patient, pharmacy, and provider agree not to seek
                    reimbursement for all, or any part of the benefit received
                    by the patient through the Program and are responsible for
                    reporting receipt of Program benefits to any insurer, health
                    plan, or other third party who pays for or reimburses any
                    part of the medication cost paid for by the Program, as may
                    be required.
                  </li>
                  <li>
                    Patients must promptly contact Celltrion CARES if their
                    insurance coverage changes.
                  </li>
                  <li>The maximum number of uses per calendar year is 14.</li>
                  <li>
                    Automatic re-enrollment is only for patients who are
                    utilizing the Program.
                  </li>
                  <li>
                    The Program is not contingent on any past or future
                    commercial sale of Adalimumab-aaty or otherwise void where
                    prohibited by law, taxed, or restricted.
                  </li>
                </ul>
              </div>
              <p className="lhight2">7. Consents and Disclaimers</p>
              <div className="pl-17 mt-15">
                <ul className="first-ul">
                  <li>
                    <strong>Data Use and Consent:</strong> Data related to a
                    patient’s participation in the Program may be collected,
                    analyzed, or shared with Celltrion CARES for market research
                    and other purposes related to assessing its co-pay
                    assistance programs. Data shared with Celltrion CARES for
                    these purposes will be de-identified, meaning it will not
                    identify the patient specifically.
                  </li>
                  <li>
                    <strong>Modification and Termination of Program: </strong>{" "}
                    Celltrion CARES reserves the right to limit, rescind,
                    revoke, terminate, or amend the Program at any time without
                    notice.
                  </li>
                </ul>
              </div>
            </div>
          </Modal.Body>
        )}
        {!productName === "steqeyma" ?? (
          <Modal.Footer className="popup-footer">
            <Button className="theme-btn" onClick={props.onHide}>
              Close
            </Button>
          </Modal.Footer>
        )}
        <div
          style={{
            fontSize: "12px",
            paddingBottom: "10px",
            paddingLeft: "52px",
          }}
        >
          Published: August 2026<br></br>
          <br></br>
          Celltrion CONNECT<sup className="reg">&reg;</sup> is a registered of
          trademark Celltrion Holdings, Ltd., used under license.<br></br>
          <br></br>
          Celltrion CARES<sup className="reg">&reg;</sup> is a registered of
          trademark Celltrion Holdings, Ltd., used under license.<br></br>
          <br></br>© Celltrion USA, Inc. 2026 {prcCode}
        </div>
      </Modal>
    </>
  );
}
export default Celltrion;
